import {useEffect, useState} from 'react';
import Button from '../../../../components/button/button';
import Message from '../../../../components/toast-message';
import {useAppInfo} from '../../../../helpers/hooks/common-hook';
import {APP_NAVIGATION} from "../../consts/navigations";
import PageContainer from "../../../../components/page-container";
import Table from "../../../../components/table";
import TableReloadButton from "../../../../components/button/table-reload-button";
import {getAppVersions, setCurrentVersion} from '../../../../services/app/app-service';

function VersionListPage() {
    const { appId } = useAppInfo();
    const [versions, setVersions] = useState([]);
    const [formState, setFormState] = useState({
        processing: false,
        success: false,
        failed: false,
        errorMessage: ''
    });
    const [toastState, setToastState] = useState({ message: '', type: '' });

    const updateFormState = (processing, success, failed, errorMessage) => {
        setFormState(Object.assign({}, { processing, success, failed, errorMessage }));
    }

    const fetchVersions = async () => {
        if (!appId) {
            return;
        }
        updateFormState(true, false, false);
        const {versions} = await getAppVersions(appId);
        setVersions(Array.isArray(versions) ? versions : []);
        updateFormState(false, true, false);
    }

    useEffect(() => {
        fetchVersions();
    }, [appId]);

    const handleSetCurrentVersion = async version => {
        updateFormState(true, false, false);
        const response = await setCurrentVersion(appId, version);
        updateFormState(false, true, false);
        fetchVersions();
    }

    const processedVersions = versions.map(version => ({
        record: version,
        columnsData: [
            { data: version.versionName || '-', isIdField: true },
            { data: version.modifiedAt, isUpdatedField: true, isDateTimeField: true },
            {
                options: [
                    {
                        name: 'Set current version',
                        onClick: () => handleSetCurrentVersion(version)
                    }
                ]
            }
        ]
    }));

    return (
        <PageContainer
            title="Versions"
            subtitle="Publish versions history"
            headerAction={<div className="flex flex-row items-center gap-4">
                <TableReloadButton onClick={fetchVersions} />
            </div>}
            navigation={APP_NAVIGATION}>

            {toastState.message &&
                <Message text={toastState.message} type={toastState.type} />
            }

            <Table
                items={processedVersions}
                headers={["Version Name"]}
                dataLoadingState={formState}
                itemsNotFoundMessage="No versions published yet"
                itemsNotFoundHelperMessage="Publish your changes to create the first version."
            />
        </PageContainer>)
}

export default VersionListPage;